import React, { Component } from 'react'
import './styles.css'
import { Formik, Field, Form } from 'formik'
import Header from '../../../components/header'
import Rodape from '../../../components/rodape'
import loader from '../../../classes/loader'
import util from '../../../classes/util'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { apiEmployee } from '../../../services/apiamrg'
import moment from 'moment'
import Skeleton from '../../../components/skeleton'
import ModalListas from '../../../components/modalListas'
import Select from 'react-select';
import Modal from '@material-ui/core/Modal';
import { CAMBIO_LIQUIDAR, DESCONTOS_CONCEDIDOS } from '../../../config'

const estadoInicial = {
    evento: '',
    os: '',

    chave: '',
    moeda: 6,
    valor: '',
    vlrc: '',
    repasse: false,
    emissao: '',
    vencimento: '',
    desconto: '',
    descontoComplemento: '',
    descontoConta: '',
    retencaoInss: '',
    retencaoInssCheck: false,
    retencaoInssComplemento: '',
    retencaoInssConta: '',
    retencaoIr: '',
    retencaoIrCheck: false,
    retencaoIrComplemento: '',
    retencaoIrConta: '',
    retencaoIss: '',
    retencaoIssCheck: false,
    retencaoIssComplemento: '',
    retencaoIssConta: '',
    retencaoPis: '',
    retencaoPisCheck: false,
    retencaoPisComplemento: '',
    retencaoPisConta: '',
    retencaoCofins: '',
    retencaoCofinsCheck: false,
    retencaoCofinsComplemento: '',
    retencaoCofinsConta: '',
    retencaoCsll: '',
    retencaoCsllCheck: false,
    retencaoCsllComplemento: '',
    retencaoCsllConta: '',
    complemento: '',
    historico: '',
    historicoPadrao: '',
    roe: 1,
    roeOriginal: 1,
    valorOriginalReais: '',

    contabiliza: false,

    moedas: [],

    planosContas: [],
    planosContasOptions: [],
    planosContasOptionsTexto: '',
    historicos: [],
    historicosOptions: [],
    historicosOptionsTexto: '',
    centrosCustos: [],
    centrosCustosOptions: [],
    centrosCustosOptionsTexto: '',
    tiposDocumentos: [],
    tiposDocumentosOptions: [],
    tiposDocumentosOptionsTexto: '',
    meiosPagamentos: [],
    meiosPagamentosOptions: [],
    meiosPagamentosOptionsTexto: '',

    tipo: '',
    contaContabil: '',
    contaDesconto: '',
    contaCredito: '',
    provisaoCheck: false,
    contaProvisao: '',
    centroCusto: '',
    historico: '',
    tipoDocumento: '',
    parcelaInicial: 1,
    parcelaFinal: 1,
    numBoleto: '',
    codBarras: '',
    meioPagamento: '',
    meioPagamentoNome: '',
    codigoReceita: '',
    contribuinte: '',
    codigoIdentificadorTributo: '',
    mesCompetNumRef: '',
    dataApuracao: '',
    darfValor: '',
    darfMulta: '',
    darfJuros: '',
    darfPagamento: '',
    darfOutros: '',

    chavePr: 0,

    acessos: [],
    permissoes: [],
    acessosPermissoes: [],

    bloqueado: false,
    bloqueadoContabiliza: false,
    loading: true,
    modalPesquisa: ''

}

class AddEventoFinanceiro extends Component {


    state = {
        ...estadoInicial,
        usuarioLogado: this.props.user
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0)
        var id = await this.props.match.params.id
        if (this.state.usuarioLogado.empresa != 0) {
            await this.setState({ empresa: this.state.usuarioLogado.empresa })
        }
        await this.setState({ chave: id })
        if (parseInt(id) != 0) {
            await this.loadAll()
            let roeCalculado = 1;
            if (this.state.evento.roe_manual && parseFloat(this.state.evento.roe_manual) > 0) {
                roeCalculado = parseFloat(this.state.evento.roe_manual);
            } else if (this.state.os && this.state.os.ROE && parseFloat(this.state.os.ROE) > 0) {
                roeCalculado = parseFloat(this.state.os.ROE);
            } else {
                roeCalculado = 1;
            }

            let totalMoedaOriginal = (parseFloat(this.state.evento.valor) || 0) * (parseFloat(this.state.evento.qntd) || 1);
            let isUsd = parseInt(this.state.evento.Moeda) === 6;
            
            let valorEmDolar = isUsd ? totalMoedaOriginal : (totalMoedaOriginal / roeCalculado);
            let valorOriginalReais = isUsd ? (totalMoedaOriginal * roeCalculado) : totalMoedaOriginal;
            let vlrcCalculado = valorEmDolar * roeCalculado;

            await this.setState({
                // tipo_sub (eventos): 0=Pagar, 1=Receber
                // Tipo (contas_aberto): 0=Receber, 1=Pagar
                // Inversão necessária entre os dois sistemas
                tipo: this.state.evento.tipo_sub == 0 ? 1 : 0,
                moeda: this.state.evento.Moeda,
                valor: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valorEmDolar),
                vlrc: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(vlrcCalculado),
                roe: roeCalculado.toFixed(6),
                roeOriginal: roeCalculado.toFixed(3),
                valorOriginalReais: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valorOriginalReais),
                documento: this.state.evento.documento,
                tipoDocumento: this.state.evento.tipo_documento,
                repasse: this.state.evento.repasse == 1 ? true : false,
                emissao: (this.state.evento.emissao && this.state.evento.emissao !== "0000-00-00") ? moment(this.state.evento.emissao).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                vencimento: (this.state.evento.vencimento && this.state.evento.vencimento !== "0000-00-00") ? moment(this.state.evento.vencimento).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
                desconto: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.evento.desconto_valor),
                descontoComplemento: this.state.evento.desconto_cpl,
                descontoConta: this.state.evento.desconto_conta,
                retencaoInss: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.evento.retencao_inss_valor),
                retencaoInssComplemento: this.state.evento.retencao_inss_cpl,
                retencaoInssConta: this.state.evento.retencao_inss_conta,
                retencaoIr: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.evento.retencao_ir_valor),
                retencaoIrComplemento: this.state.evento.retencao_ir_cpl,
                retencaoIrConta: this.state.evento.retencao_ir_conta,
                retencaoIss: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.evento.retencao_iss_valor),
                retencaoIssComplemento: this.state.evento.retencao_iss_cpl,
                retencaoIssConta: this.state.evento.retencao_iss_conta,
                retencaoPis: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.evento.retencao_pis_valor),
                retencaoPisComplemento: this.state.evento.retencao_pis_cpl,
                retencaoPisConta: this.state.evento.retencao_pis_conta,
                retencaoCofins: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.evento.retencao_cofins_valor),
                retencaoCofinsComplemento: this.state.evento.retencao_cofins_cpl,
                retencaoCofinsConta: this.state.evento.retencao_cofins_conta,
                retencaoCsll: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.state.evento.retencao_csll_valor),
                retencaoCsllComplemento: this.state.evento.retencao_csll_cpl,
                retencaoCsllConta: this.state.evento.retencao_csll_conta,
                complemento: this.state.evento.complemento,
                contaTaxa: this.state.evento.contaTaxa,
                contaCliente: this.state.evento.contaCliente,
                contaFornecedor: this.state.evento.contaFornecedor,
                contaFornecedorCusteio: this.state.evento.contaFornecedorCusteio,

                navio: this.state.evento.navioNome,
                fornecedorNome: this.state.evento.fornecedorNome,

            })

            this.setState({
                historico: `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`
            })

            if (!this.state.descontoConta || this.state.descontoConta == '0') {
                await this.setState({
                    descontoConta: this.state.parametros[0].conta_desconto
                })
            }

            await this.setState({
                retencaoInssCheck: this.state.evento.retencao_inss_conta && this.state.evento.retencao_inss_conta != '0',
                retencaoIrCheck: this.state.evento.retencao_ir_conta && this.state.evento.retencao_ir_conta != '0',
                retencaoIssCheck: this.state.evento.retencao_iss_conta && this.state.evento.retencao_iss_conta != '0',
                retencaoPisCheck: this.state.evento.retencao_pis_conta && this.state.evento.retencao_pis_conta != '0',
                retencaoCofinsCheck: this.state.evento.retencao_cofins_conta && this.state.evento.retencao_cofins_conta != '0',
                retencaoCsllCheck: this.state.evento.retencao_csll_conta && this.state.evento.retencao_csll_conta != '0',
            })

            await this.setState({
                dadosIniciais: [
                    { titulo: 'Moeda', valor: util.formatForLogs(this.state.moeda, 'options', '', '', this.state.moedas, 'Chave', 'Sigla') },
                    { titulo: 'Valor', valor: util.formatForLogs(this.state.valor, 'money') },
                    { titulo: 'ROE', valor: this.state.roe },
                    { titulo: 'Valor Final', valor: util.formatForLogs(this.state.vlrc, 'money') },
                    { titulo: 'Repasse', valor: util.formatForLogs(this.state.repasse, 'bool') },
                    { titulo: 'Emissao', valor: util.formatForLogs(this.state.emissao, 'date') },
                    { titulo: 'Vencimento', valor: util.formatForLogs(this.state.vencimento, 'date') },
                    { titulo: 'Valor de Desconto', valor: util.formatForLogs(this.state.desconto) },
                    { titulo: 'Complemento de Desconto', valor: util.formatForLogs(this.state.descontoComplemento) },
                    { titulo: 'Conta de Desconto', valor: util.formatForLogs(this.state.descontoConta, 'options', '', '', this.state.planosContasOptions) },
                    { titulo: 'Valor de INSS', valor: util.formatForLogs(this.state.retencaoInss, 'money') },
                    { titulo: 'Complemento de INSS', valor: util.formatForLogs(this.state.retencaoInssComplemento) },
                    { titulo: 'Conta de INSS', valor: util.formatForLogs(this.state.retencaoInssConta, 'options', '', '', this.state.planosContasOptions) },
                    { titulo: 'Valor de IR', valor: util.formatForLogs(this.state.retencaoIr, 'money') },
                    { titulo: 'Complemento de IR', valor: util.formatForLogs(this.state.retencaoIrComplemento) },
                    { titulo: 'Conta de IR', valor: util.formatForLogs(this.state.retencaoIrConta, 'options', '', '', this.state.planosContasOptions) },
                    { titulo: 'Valor de ISS', valor: util.formatForLogs(this.state.retencaoIss, 'money') },
                    { titulo: 'Complemento de ISS', valor: util.formatForLogs(this.state.retencaoIssComplemento) },
                    { titulo: 'Conta de ISS', valor: util.formatForLogs(this.state.retencaoIssConta, 'options', '', '', this.state.planosContasOptions) },
                    { titulo: 'Valor de PIS', valor: util.formatForLogs(this.state.retencaoPis, 'money') },
                    { titulo: 'Complemento de PIS', valor: util.formatForLogs(this.state.retencaoPisComplemento) },
                    { titulo: 'Conta de PIS', valor: util.formatForLogs(this.state.retencaoPisConta, 'options', '', '', this.state.planosContasOptions) },
                    { titulo: 'Valor de COFINS', valor: util.formatForLogs(this.state.retencaoCofins, 'money') },
                    { titulo: 'Complemento de COFINS', valor: util.formatForLogs(this.state.retencaoCofinsComplemento) },
                    { titulo: 'Conta de COFINS', valor: util.formatForLogs(this.state.retencaoCofinsConta, 'options', '', '', this.state.planosContasOptions) },
                    { titulo: 'Valor de CSLL', valor: util.formatForLogs(this.state.retencaoCsll, 'money') },
                    { titulo: 'Complemento de CSLL', valor: util.formatForLogs(this.state.retencaoCsllComplemento) },
                    { titulo: 'Conta de CSLL', valor: util.formatForLogs(this.state.retencaoCsllConta, 'options', '', '', this.state.planosContasOptions) },
                    { titulo: 'Complemento', valor: util.formatForLogs(this.state.complemento) },
                    { titulo: 'Conta Contabil', valor: util.formatForLogs(this.state.contaContabil, 'options', '', '', this.state.planosContasOptions) }
                ],
                loading: false
            })
        } else {
            this.setState({ loading: false })
        }

        this.state.acessosPermissoes.map((e) => {
            if ((e.acessoAcao == "SERVICOS_ITENS" && e.permissaoInsere == 0 && this.state.chave == 0) || (e.acessoAcao == "SERVICOS_ITENS" && e.permissaoEdita == 0 && this.state.chave != 0)) {
                this.setState({ bloqueado: true })
            }
        })
    }

    loadAll = async () => {
        await this.setState({
            evento: await loader.getOne('getSolicitacao.php', this.state.chave),
            conta: await loader.getContaSolicitacao(this.state.chave),

            historicos: await loader.getBase('getHistoricos.php'),
            historicosOptions: await loader.getHistoricosOptions(),

            planosContas: await loader.getBase('getPlanosContasAnaliticas.php'),
            planosContasOptions: await loader.getPlanosContasAnaliticasOptions(),

            centrosCustos: await loader.getBase('getCentrosCustos.php'),
            centrosCustosOptions: await loader.getBaseOptions('getCentrosCustos.php', 'Descricao', 'Chave'),

            tiposDocumentos: await loader.getBase('getTiposLancamento.php'),
            tiposDocumentosOptions: await loader.getTiposLancamentoOptions(),

            meiosPagamentos: await loader.getBase('getMeiosPagamentos.php'),
            meiosPagamentosOptions: await loader.getMeiosPagamentosOptions(),

            moedas: await loader.getBase('getMoedas.php'),

            parametros: await loader.getBody('getParametros.php', { token: true, empresa: this.state.usuarioLogado.empresa }),

            acessos: await loader.getBase('getTiposAcessos.php'),
            permissoes: await loader.getBase('getPermissoes.php')
        })

        const planosContasOptions = this.state.planosContasOptions;
        planosContasOptions.unshift({ label: "Select...", value: "" });

        await this.setState({
            planosContasOptions,
            parametroInss: this.state.parametros[0].conta_retencao_inss,
            parametroIr: this.state.parametros[0].conta_retencao_ir,
            parametroIss: this.state.parametros[0].conta_retencao_iss,
            parametroPis: this.state.parametros[0].conta_retencao_pis,
            parametroCofins: this.state.parametros[0].conta_retencao_cofins,
            parametroCsll: this.state.parametros[0].conta_retencao_csll,

            acessosPermissoes: await loader.testaAcesso(this.state.acessos, this.state.permissoes, this.state.usuarioLogado),
            loading: false
        })

        await this.getOSUma();
    }

    alteraComplementoRetencoes = () => {
        this.setState({
            historico: `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`,
            descontoComplemento: this.state.desconto > 0 ? `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}` : "",
            retencaoCsllComplemento: this.state.retencaoCsllCheck ? `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}` : "",
            retencaoInssComplemento: this.state.retencaoInssCheck ? `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}` : "",
            retencaoIrComplemento: this.state.retencaoIrCheck ? `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}` : "",
            retencaoIssComplemento: this.state.retencaoIssCheck ? `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}` : "",
        })
    }

    salvarServicoItem = async (validForm) => {
        this.setState({ ...util.cleanStates(this.state) })
        this.setState({ bloqueado: true });

        this.setState({
            historico: `Valor referente Doc ${this.state.documento ? this.state.documento : ""} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`
        })

        await this.setState({
            dadosFinais: [
                { titulo: 'Moeda', valor: util.formatForLogs(this.state.moeda, 'options', '', '', this.state.moedas, 'Chave', 'Sigla') },
                { titulo: 'Valor', valor: util.formatForLogs(this.state.valor, 'money') },
                { titulo: 'ROE', valor: this.state.roe },
                { titulo: 'Valor Final', valor: util.formatForLogs(this.state.vlrc, 'money') },
                { titulo: 'Repasse', valor: util.formatForLogs(this.state.repasse, 'bool') },
                { titulo: 'Emissao', valor: util.formatForLogs(this.state.emissao, 'date') },
                { titulo: 'Vencimento', valor: util.formatForLogs(this.state.vencimento, 'date') },
                { titulo: 'Valor de Desconto', valor: util.formatForLogs(this.state.desconto) },
                { titulo: 'Complemento de Desconto', valor: util.formatForLogs(this.state.descontoComplemento) },
                { titulo: 'Conta de Desconto', valor: util.formatForLogs(this.state.descontoConta, 'options', '', '', this.state.planosContasOptions) },
                { titulo: 'Valor de INSS', valor: util.formatForLogs(this.state.retencaoInss, 'money') },
                { titulo: 'Complemento de INSS', valor: util.formatForLogs(this.state.retencaoInssComplemento) },
                { titulo: 'Conta de INSS', valor: util.formatForLogs(this.state.retencaoInssConta, 'options', '', '', this.state.planosContasOptions) },
                { titulo: 'Valor de IR', valor: util.formatForLogs(this.state.retencaoIr, 'money') },
                { titulo: 'Complemento de IR', valor: util.formatForLogs(this.state.retencaoIrComplemento) },
                { titulo: 'Conta de IR', valor: util.formatForLogs(this.state.retencaoIrConta, 'options', '', '', this.state.planosContasOptions) },
                { titulo: 'Valor de ISS', valor: util.formatForLogs(this.state.retencaoIss, 'money') },
                { titulo: 'Complemento de ISS', valor: util.formatForLogs(this.state.retencaoIssComplemento) },
                { titulo: 'Conta de ISS', valor: util.formatForLogs(this.state.retencaoIssConta, 'options', '', '', this.state.planosContasOptions) },
                { titulo: 'Valor de PIS', valor: util.formatForLogs(this.state.retencaoPis, 'money') },
                { titulo: 'Complemento de PIS', valor: util.formatForLogs(this.state.retencaoPisComplemento) },
                { titulo: 'Conta de PIS', valor: util.formatForLogs(this.state.retencaoPisConta, 'options', '', '', this.state.planosContasOptions) },
                { titulo: 'Valor de COFINS', valor: util.formatForLogs(this.state.retencaoCofins, 'money') },
                { titulo: 'Complemento de COFINS', valor: util.formatForLogs(this.state.retencaoCofinsComplemento) },
                { titulo: 'Conta de COFINS', valor: util.formatForLogs(this.state.retencaoCofinsConta, 'options', '', '', this.state.planosContasOptions) },
                { titulo: 'Valor de CSLL', valor: util.formatForLogs(this.state.retencaoCsll, 'money') },
                { titulo: 'Complemento de CSLL', valor: util.formatForLogs(this.state.retencaoCsllComplemento) },
                { titulo: 'Conta de CSLL', valor: util.formatForLogs(this.state.retencaoCsllConta, 'options', '', '', this.state.planosContasOptions) },
                { titulo: 'Complemento', valor: util.formatForLogs(this.state.complemento) },
                { titulo: 'Conta Contabil', valor: util.formatForLogs(this.state.contaContabil, 'options', '', '', this.state.planosContasOptions) }
            ],
            loading: true
        })

        if (parseInt(this.state.chave) === 0 && validForm) {
            return;
        } else if (validForm) {
            const isUsd = parseInt(this.state.moeda) === 6;
            const roeFinal = parseFloat(this.state.roe) > 0 ? parseFloat(this.state.roe) : 1;

            const valorTelaDolar = parseFloat(this.state.valor.replaceAll('.', '').replaceAll(',', '.'));
            const valorUnitario = isUsd ? valorTelaDolar : (valorTelaDolar * roeFinal);
            
            const vcpInformado = parseFloat(this.state.vlrc.replaceAll('.', '').replaceAll(',', '.'));
            const valorVcp = vcpInformado > 0 ? vcpInformado : (valorTelaDolar * roeFinal);

            const parseRetencao = (val) => {
                if (!val) return 0;
                const parsed = parseFloat(val.toString().replaceAll('.', '').replaceAll(',', '.'));
                return isUsd ? parsed / roeFinal : parsed;
            };

            await apiEmployee.post(`updateServicoItemFinanceiro.php`, {
                token: true,
                chave: this.state.chave,
                centro_custo: this.state.evento.centroCusto,
                conta_cliente: this.state.contaCliente,
                conta_fornecedor: this.state.contaFornecedor || this.state.contaFornecedorCusteio,
                conta_taxa: this.state.contaTaxa,
                Moeda: this.state.moeda,
                valor: valorUnitario,
                valor1: valorVcp,
                repasse: this.state.repasse ? 1 : 0,
                emissao: moment(this.state.emissao).format('YYYY-MM-DD'),
                vencimento: moment(this.state.vencimento).format('YYYY-MM-DD'),
                documento: this.state.documento,
                tipo_documento: this.state.tipoDocumento,
                desconto_valor: parseRetencao(this.state.desconto),
                desconto_cpl: this.state.descontoComplemento,
                desconto_conta: this.state.descontoConta,
                retencao_inss_valor: parseRetencao(this.state.retencaoInss),
                retencao_inss_cpl: this.state.retencaoInssComplemento,
                retencao_inss_conta: this.state.retencaoInssConta,
                retencao_ir_valor: parseRetencao(this.state.retencaoIr),
                retencao_ir_cpl: this.state.retencaoIrComplemento,
                retencao_ir_conta: this.state.retencaoIrConta,
                retencao_iss_valor: parseRetencao(this.state.retencaoIss),
                retencao_iss_cpl: this.state.retencaoIssComplemento,
                retencao_iss_conta: this.state.retencaoIssConta,
                retencao_pis_valor: parseRetencao(this.state.retencaoPis),
                retencao_pis_cpl: this.state.retencaoPisComplemento,
                retencao_pis_conta: this.state.retencaoPisConta,
                retencao_cofins_valor: parseRetencao(this.state.retencaoCofins),
                retencao_cofins_cpl: this.state.retencaoCofinsComplemento,
                retencao_cofins_conta: this.state.retencaoCofinsConta,
                retencao_csll_valor: parseRetencao(this.state.retencaoCsll),
                retencao_csll_cpl: this.state.retencaoCsllComplemento,
                retencao_csll_conta: this.state.retencaoCsllConta,
                complemento: this.state.complemento,
            }).then(
                async res => {
                    if (res.data === true) {
                        await loader.salvaLogs('os_servicos_itens', this.state.usuarioLogado.codigo, this.state.dadosIniciais, this.state.dadosFinais, this.state.chave);

                        await this.setState({ loading: false });
                        if (!this.state.contabiliza) {
                            await this.setState({ loading: false, bloqueado: false })
                        }
                    } else {
                        await alert(`Erro ${JSON.stringify(res)}`)
                    }
                },
                async res => await console.log(`Erro: ${res}`)
            )

        }

    }

    contabilizar = async (validForm) => {
        this.setState({
            contaDebito: this.state.tipo == 1
                ? this.state.repasse
                    ? this.state.contaCliente
                    : this.state.contaFornecedor || this.state.contaFornecedorCusteio  // ← Débito = Fornecedor
                : this.state.contaCliente,

            contaCredito: this.state.tipo == 1
                ? this.state.repasse
                    ? this.state.contaFornecedor || this.state.contaFornecedorCusteio  // Com repasse
                    : this.state.contaDesconto  // ← Sem repasse: banco!
                : this.state.contaTaxa,
        });


        await this.setState({ contabiliza: true });
        await this.salvarServicoItem(validForm);
    }

    transformaRetencoes = async () => {
        const retencoes = [];
        const isUsd = parseInt(this.state.moeda) === 6;
        const roeFinal = parseFloat(this.state.roe) > 0 ? parseFloat(this.state.roe) : 1;
        
        const parseRetencao = (val) => {
            if (!val) return 0;
            const parsed = parseFloat(val.toString().replaceAll('.', '').replaceAll(',', '.'));
            return isUsd ? parsed / roeFinal : parsed;
        };

        if (this.state.desconto > 0) {
            retencoes.push(`'${this.state.descontoConta}', ${parseRetencao(this.state.desconto)}, '${this.state.descontoComplemento}', 'DESCONTO'`);
        }
        if (this.state.retencaoCofinsCheck) {
            retencoes.push(`'${this.state.retencaoCofinsConta}', ${parseRetencao(this.state.retencaoCofins)}, '${this.state.retencaoCofinsComplemento}', 'COFINS'`);
        }
        if (this.state.retencaoCsllCheck) {
            retencoes.push(`'${this.state.retencaoCsllConta}', ${parseRetencao(this.state.retencaoCsll)}, '${this.state.retencaoCsllComplemento}', 'CRF'`);
        }
        if (this.state.retencaoInssCheck) {
            retencoes.push(`'${this.state.retencaoInssConta}', ${parseRetencao(this.state.retencaoInss)}, '${this.state.retencaoCofinsInss}', 'INSS'`);
        }
        if (this.state.retencaoIrCheck) {
            retencoes.push(`'${this.state.retencaoIrConta}', ${parseRetencao(this.state.retencaoIr)}, '${this.state.retencaoIrComplemento}', 'IR'`);
        }
        if (this.state.retencaoIssCheck) {
            retencoes.push(`'${this.state.retencaoIssConta}', ${parseRetencao(this.state.retencaoIss)}, '${this.state.retencaoIssComplemento}', 'ISS'`);
        }
        if (this.state.retencaoPisCheck) {
            retencoes.push(`'${this.state.retencaoPisConta}', ${parseRetencao(this.state.retencaoPis)}, '${this.state.retencaoPisComplemento}', 'PIS'`);
        }

        return retencoes;
    }

    calculaValor = async () => {
        let rawValor = String(this.state.vlrc || "0");
        let valor = parseFloat(rawValor.replaceAll(".", "").replaceAll(",", "."));
        if (isNaN(valor)) valor = 0;

        if (this.state.desconto > 0) {
            valor -= parseFloat(this.state.desconto.replaceAll(".", "").replaceAll(",", "."));
        }
        if (this.state.retencaoCofinsCheck) {
            valor -= parseFloat(this.state.retencaoCofins.replaceAll(".", "").replaceAll(",", "."));
        }
        if (this.state.retencaoCsllCheck) {
            valor -= parseFloat(this.state.retencaoCsll.replaceAll(".", "").replaceAll(",", "."));
        }
        if (this.state.retencaoInssCheck) {
            valor -= parseFloat(this.state.retencaoInss.replaceAll(".", "").replaceAll(",", "."));
        }
        if (this.state.retencaoIrCheck) {
            valor -= parseFloat(this.state.retencaoIr.replaceAll(".", "").replaceAll(",", "."));
        }
        if (this.state.retencaoIssCheck) {
            valor -= parseFloat(this.state.retencaoIss.replaceAll(".", "").replaceAll(",", "."));
        }
        if (this.state.retencaoPisCheck) {
            valor -= parseFloat(this.state.retencaoPis.replaceAll(".", "").replaceAll(",", "."));
        }
        // Descontar adiantamento se existir
        if (this.state.evento && this.state.evento.adiantamento && parseFloat(this.state.evento.adiantamento) > 0) {
            valor -= parseFloat(this.state.evento.adiantamento);
        }

        // Se a moeda for Dólar (6), o valor final precisa ser salvo na moeda original (USD),
        // mas as retenções/descontos e o vlrc estão em Reais (BRL).
        // Portanto, calculamos tudo em Reais e, no final, dividimos pelo ROE para obter o valor em USD.
        let isUsd = parseInt(this.state.moeda) === 6;
        let roeFinal = parseFloat(this.state.roe) > 0 ? parseFloat(this.state.roe) : 1;
        
        return isUsd ? valor / roeFinal : valor;
    }

    salvarConta = async (validFormContabiliza) => {

        this.setState({ bloqueadoContabiliza: true, loading: true });

        const retencoes = await this.transformaRetencoes();
        const valorFinal = await this.calculaValor();

        let pessoaId;
        if (this.state.tipo == 0) {
            pessoaId = this.state.os?.Chave_Cliente || this.state.evento?.fornecedor;
        } else {
            pessoaId = this.state.evento.fornecedor || this.state.evento.Fornecedor_Custeio;
        }

        if (validFormContabiliza) {
            await apiEmployee.post(`insertContaFornecedor.php`, {
                token: true,
                values: `'${this.state.emissao}', '${this.state.tipo}', '${pessoaId}', '${this.state.tipo == 0 ? this.state.contaCredito : this.state.contaDebito}', '${this.state.codBarras}', '${this.state.evento.centroCusto}', '${this.state.historico}', '${this.state.tipo == 0 ? this.state.contaCliente : this.state.contaDesconto}', '${1}', '${1}', '${parseFloat(valorFinal)}', '${this.state.vencimento}', '${this.state.vencimento}', '${this.state.contaProvisao}', '${valorFinal}', '${this.state.usuarioLogado.codigo}', '${this.state.empresa}', '${this.state.documento}', '${this.state.tipoDocumento}', '${this.state.meioPagamento}', '${this.state.chave}', NULL`,
                meioPagamento: this.state.meioPagamentoNome,
                valuesDarf: `''`,
                valuesRet: retencoes,
                dadosManuais: `NULL, NULL, NULL, '${this.state.roe}', NULL, NULL, NULL`,
                osOrigem: this.state.os?.Chave || this.state.evento?.chave_os
            }).then(
                async res => {
                    if (res.data[0]) {
                        await this.setState({ chavePr: res.data[0].Chave });
                        await loader.salvaLogs('os_contas_aberto', this.state.usuarioLogado.codigo, null, "Inclusão", res.data[0].chave);

                    } else {
                        await alert(`Erro ${JSON.stringify(res.data)}`)
                    }
                },
                async res => await console.log(`Erro: ${res.data}`)
            )

            await apiEmployee.post(`contabilizaEvento.php`, {
                token: true,
                repasse: this.state.repasse,
                tipoEvento: this.state.evento.tipo_sub,
                tipo: this.state.tipo,
                values: `'${moment().format("YYYY-MM-DD")}', '${this.state.tipoDocumento}', '${this.state.evento.centroCusto}', '${this.state.historicoPadrao}', '${this.state.os.Chave_Cliente}', '${this.state.chavePr}', '${this.state.usuarioLogado.codigo}', '${this.state.usuarioLogado.codigo}', '${moment().format('YYYY-MM-DD')}', '${moment().format('YYYY-MM-DD')}'`,
                historico: `${this.state.historico}`,
                chave_evento: this.state.chave,
                chave_taxa: this.state.evento.taxa,
                contaDebito: this.state.contaDebito || 0,
                contaCredito: this.state.contaCredito || 0,
            }).then(
                async res => {
                },
                async res => await console.log(`Erro: ${res.data}`)
            )

        }

        await this.setState({ loading: false, bloqueado: false, contabiliza: false, bloqueadoContabiliza: false })
    }

    mudaRetencao = async (tipo) => {
        if (tipo == "INSS") {
            if (this.state.retencaoInssCheck) {
                await this.setState({
                    retencaoInssCheck: false,
                    retencaoInssConta: 0,
                    retencaoInss: '',
                    retencaoInssComplemento: ''
                })
            } else {
                await this.setState({
                    retencaoInssCheck: true,
                    retencaoInssConta: this.state.parametroInss,
                    retencaoInssComplemento: `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`,
                })
            }
        } else if (tipo == "IR") {
            if (this.state.retencaoIrCheck) {
                await this.setState({
                    retencaoIrCheck: false,
                    retencaoIrConta: 0,
                    retencaoIr: '',
                    retencaoIrComplemento: '',
                })
            } else {
                await this.setState({
                    retencaoIrCheck: true,
                    retencaoIrConta: this.state.parametroIr,
                    retencaoIrComplemento: `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`
                })
            }
        } else if (tipo == "ISS") {
            if (this.state.retencaoIssCheck) {
                await this.setState({
                    retencaoIssCheck: false,
                    retencaoIssConta: 0,
                    retencaoIss: '0',
                    retencaoIssComplemento: ''
                })
            } else {
                await this.setState({
                    retencaoIssCheck: true,
                    retencaoIssConta: this.state.parametroIss,
                    retencaoIssComplemento: `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`
                })
            }
        } else if (tipo == "PIS") {
            if (this.state.retencaoPisCheck) {
                await this.setState({
                    retencaoPisCheck: false,
                    retencaoPisConta: 0,
                    retencaoPis: '',
                    retencaoPisComplemento: ''
                })
            } else {
                await this.setState({
                    retencaoPisCheck: true,
                    retencaoPisConta: this.state.parametroPis,
                    retencaoPisComplemento: `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`
                })
            }
        } else if (tipo == "COFINS") {
            if (this.state.retencaoCofinsCheck) {
                await this.setState({
                    retencaoCofinsCheck: false,
                    retencaoCofinsConta: 0,
                    retencaoCofins: '',
                    retencaoCofinsComplemento: ''
                })
            } else {
                await this.setState({
                    retencaoCofinsCheck: true,
                    retencaoCofinsConta: this.state.parametroCofins,
                    retencaoCofinsComplemento: `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`
                })
            }
        } else if (tipo == "CSLL") {
            if (this.state.retencaoCsllCheck) {
                await this.setState({
                    retencaoCsllCheck: false,
                    retencaoCsllConta: 0,
                    retencaoCsll: '',
                    retencaoCsllComplemento: ''
                })
            } else {
                await this.setState({
                    retencaoCsllCheck: true,
                    retencaoCsllConta: this.state.parametroCsll,
                    retencaoCsllComplemento: `Valor referente Doc ${this.state.documento} ${this.state.fornecedorNome} ${this.state.os.codigo} NAVIO ${this.state.navio}`
                })
            }
        }
    }

    erroApi = async (res) => {
        alert(res)
        await this.setState({ redirect: true })
    }

    alteraModal = async (valor) => {
        this.setState({ modal: valor });
    }

    alteraPlanoConta = async (valor, indicador) => {
        if (indicador == 'A') {
            if (this.state.formAtivo == 'desc') {
                await this.setState({ descontoConta: valor });
            } else if (this.state.formAtivo == 'ret1') {
                await this.setState({ retencao1Conta: valor });
            } else if (this.state.formAtivo == 'ret2') {
                await this.setState({ retencao2Conta: valor })
            }
        }
        await this.setState({
            modalAberto: false,
            planosContas: await loader.getBase('getPlanosContasAnaliticas.php'),
            planosContas: await loader.getBaseOptions('getPlanosContasAnaliticas.php', 'Descricao', 'Chave'),
            planosContasOptions: await loader.getPlanosContasAnaliticasOptions(),
        });
    }

    getOSUma = async () => {
        await apiEmployee.post(`getOSUma.php`, {
            token: true,
            chave_os: this.state.evento.chave_os
        }).then(
            async res => {
                await this.setState({ os: res.data[0] })
            },
            async err => { this.erroApi(err) }
        )
    }

    trocarTipoContabilizar = async (value) => {
        console.log(this.state.evento)
        await this.setState({ tipo: value, pessoa: '', contaDesconto: '' });

        if (this.state.evento.tipo_sub == 1) {
            if (this.state.tipo == '0') {
                this.setState({ contaDesconto: await loader.getContaTaxa(this.state.evento.taxa) })
                console.log(this.state.contaDesconto);
            } else if (this.state.tipo == 1) {
                this.setState({ contaDesconto: await loader.getContaPessoa(this.state.os.Chave_Cliente) })
            }
        } else if (this.state.evento.tipo_sub == 0) {
            if (this.state.repasse) {
                if (this.state.tipo == '0') {
                    this.setState({
                        contaDesconto: await loader.getContaPessoa(!this.state.evento.fornecedor || this.state.evento.fornecedor === "0" ? this.state.evento.Fornecedor_Custeio : this.state.evento.fornecedor, "provisao"),
                        contaCredito: await loader.getContaPessoa(this.state.os.Chave_Cliente)
                    })
                } else if (this.state.tipo == 1) {
                    this.setState({
                        contaDesconto: await loader.getContaPessoa(this.state.os.Chave_Cliente),
                        contaCredito: await loader.getContaPessoa(!this.state.evento.fornecedor || this.state.evento.fornecedor === "0" ? this.state.evento.Fornecedor_Custeio : this.state.evento.fornecedor, "provisao"),
                    })
                }
            } else {
                if (this.state.tipo == '0') {
                    this.setState({
                        contaDesconto: await loader.getContaPessoa(!this.state.evento.fornecedor || this.state.evento.fornecedor === "0" ? this.state.evento.Fornecedor_Custeio : this.state.evento.fornecedor, "provisao")
                    });
                } else if (this.state.tipo == '1') {
                    this.setState({
                        contaCredito: await loader.getContaPessoa(!this.state.evento.fornecedor || this.state.evento.fornecedor === "0" ? this.state.evento.Fornecedor_Custeio : this.state.evento.fornecedor, "provisao")
                    });
                }
            }
        } else if (this.state.evento.tipo_sub == 2) {
            this.setState({
                contaDesconto: CAMBIO_LIQUIDAR,
                contaCredito: await loader.getContaPessoa(this.state.os.Chave_Cliente)
            });
        } else if (this.state.evento.tipo_sub == 3) {
            this.setState({
                contaDesconto: DESCONTOS_CONCEDIDOS,
                contaCredito: await loader.getContaPessoa(this.state.os.Chave_Cliente)
            });
        }
    }

    filterSearch = (e, state) => {
        if (e == "") {
            return true
        }

        const text = state.toUpperCase();
        return (e.label.toUpperCase().includes(text))

    }

    testaValores = () => {
        // Função auxiliar blindada contra undefined e letras
        const paraFloat = (v) => {
            if (!v) return 0;
            const numero = parseFloat(v.toString().replaceAll(".", "").replaceAll(",", "."));
            return isNaN(numero) ? 0 : numero;
        };

        const totalImpostosEDescontos =
            paraFloat(this.state.desconto) +
            paraFloat(this.state.retencaoPis) +
            paraFloat(this.state.retencaoCofins) +
            paraFloat(this.state.retencaoCsll) +
            paraFloat(this.state.retencaoInss) +
            paraFloat(this.state.retencaoIr) +
            paraFloat(this.state.retencaoIss);

        const vcpTotal = paraFloat(this.state.vlrc);

        // Se total de retenções for MAIOR que o VCP, retorna true (para travar o botão)
        return totalImpostosEDescontos > vcpTotal;
    }

    aplicarMascaraATM = (valorDigitado) => {
        if (!valorDigitado) return '0,00';

        // 1. Remove absolutamente tudo que não for dígito numérico
        let apenasNumeros = valorDigitado.toString().replace(/\D/g, '');

        // 2. Converte para inteiro (isso remove os zeros à esquerda inúteis)
        let valorInt = parseInt(apenasNumeros, 10);

        // Se o usuário apagou tudo com backspace
        if (isNaN(valorInt)) return '0,00';

        // 3. Divide por 100 para que os dois últimos números virem centavos
        let valorFinal = valorInt / 100;

        // 4. Devolve já no formato 1.000,00
        return new Intl.NumberFormat('pt-BR', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(valorFinal);
    }

    recalculaVlrc = (valorStr, roeStr) => {
        let valorStrSafe = String(valorStr);
        let valor = parseFloat(valorStrSafe.replaceAll(".", "").replaceAll(",", "."));
        if (isNaN(valor)) valor = 0;
        let roeStrSafe = String(roeStr).replaceAll(",", ".");
        let roe = parseFloat(roeStrSafe);
        if (isNaN(roe)) roe = 1;
        
        let calculado = valor * roe;
        
        this.setState({
            vlrc: new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(calculado)
        });
    }

    // Dispara a cada tecla digitada no Valor Original
    handleChangeValorOriginal = async (e) => {
        const valorFormatado = this.aplicarMascaraATM(e.currentTarget.value);
        await this.setState({ valor: valorFormatado });
        this.recalculaVlrc(valorFormatado, this.state.roe);
    }

    handleChangeROE = async (e) => {
        let val = e.currentTarget.value.replace(/[^0-9,.]/g, ''); 
        await this.setState({ roe: val });
        this.recalculaVlrc(this.state.valor, val);
    }

    render() {
        const validations = []
        validations.push(this.state.valor && this.state.valor.replaceAll('.', '').replaceAll(',', '.') == parseFloat(this.state.valor.replaceAll('.', '').replaceAll(',', '.')))
        validations.push((!this.state.repasse && !this.state.vlrc) || this.state.vlrc.replaceAll('.', '').replaceAll(',', '.') == parseFloat(this.state.vlrc.replaceAll('.', '').replaceAll(',', '.')) && (!this.state.repasse || this.state.vlrc == this.state.valor))
        validations.push(!this.state.desconto || this.state.desconto.replaceAll('.', '').replaceAll(',', '.') == parseFloat(this.state.desconto.replaceAll('.', '').replaceAll(',', '.')))
        validations.push(this.state.moeda)
        validations.push(!this.state.bloqueado)

        const validForm = validations.reduce((t, a) => t && a)

        const validationsContabiliza = []
        validationsContabiliza.push(this.state.valor && this.state.valor.replaceAll('.', '').replaceAll(',', '.') == parseFloat(this.state.valor.replaceAll('.', '').replaceAll(',', '.')))
        validationsContabiliza.push((!this.state.repasse && !this.state.vlrc) || this.state.vlrc.replaceAll('.', '').replaceAll(',', '.') == parseFloat(this.state.vlrc.replaceAll('.', '').replaceAll(',', '.')) && (!this.state.repasse || this.state.vlrc == this.state.valor))
        validationsContabiliza.push(!this.state.desconto || this.state.desconto.replaceAll('.', '').replaceAll(',', '.') == parseFloat(this.state.desconto.replaceAll('.', '').replaceAll(',', '.')))
        validationsContabiliza.push(this.state.vencimento)
        validationsContabiliza.push(parseFloat(this.state.vlrc.replaceAll('.', '').replaceAll(',', '.')) > 0)
        validationsContabiliza.push(this.state.meioPagamento)
        validationsContabiliza.push(this.state.meioPagamentoNome != 'DARF' && this.state.meioPagamentoNome != 'GPS' || this.state.codigoReceita)
        validationsContabiliza.push(this.state.meioPagamentoNome != 'DARF' && this.state.meioPagamentoNome != 'GPS' || this.state.contribuinte)
        validationsContabiliza.push(this.state.meioPagamentoNome != 'DARF' && this.state.meioPagamentoNome != 'GPS' || this.state.codigoIdentificadorTributo)
        validationsContabiliza.push(this.state.meioPagamentoNome != 'DARF' && this.state.meioPagamentoNome != 'GPS' || this.state.mesCompetNumRef)
        validationsContabiliza.push(this.state.meioPagamentoNome != 'DARF' && this.state.meioPagamentoNome != 'GPS' || this.state.dataApuracao)
        validationsContabiliza.push(this.state.meioPagamentoNome != 'DARF' && this.state.meioPagamentoNome != 'GPS' || this.state.darfValor && this.state.darfValor.replaceAll('.', '').replaceAll(',', '.') == parseFloat(this.state.darfValor.replaceAll('.', '').replaceAll(',', '.')))
        validationsContabiliza.push(this.state.meioPagamentoNome != 'DARF' && this.state.meioPagamentoNome != 'GPS' || this.state.darfPagamento && this.state.darfPagamento.replaceAll('.', '').replaceAll(',', '.') == parseFloat(this.state.darfPagamento.replaceAll('.', '').replaceAll(',', '.')))
        validationsContabiliza.push(!this.state.bloqueadoContabiliza)

        const validFormContabiliza = validationsContabiliza.reduce((t, a) => t && a)

        console.log('=== DIAGNÓSTICO DE CONTABILIZAÇÃO ===');
        console.log('Evento:', this.state.evento);
        console.log('Já contabilizado?', !!this.state.conta);
        console.log('Centro de custo:', this.state.evento.centroCusto);
        console.log('Tipo:', this.state.tipo, '(0=Receber, 1=Pagar, 2=Câmbio, 3=Descontos)');
        console.log('Repasse:', this.state.repasse);
        console.log('contaCliente:', this.state.contaCliente);
        console.log('contaTaxa:', this.state.contaTaxa);
        console.log('contaFornecedor:', this.state.contaFornecedor);
        console.log('contaFornecedorCusteio:', this.state.contaFornecedorCusteio);
        console.log('contaDebito:', this.state.contaDebito);
        console.log('contaCredito:', this.state.contaCredito);
        console.log('Valor original (vlrc):', this.state.vlrc);
        console.log('Desconto:', this.state.desconto);
        console.log('Soma retenções:',
            parseFloat(this.state.desconto || 0) +
            parseFloat(this.state.retencaoInss || 0) +
            parseFloat(this.state.retencaoIr || 0) +
            parseFloat(this.state.retencaoIss || 0) +
            parseFloat(this.state.retencaoPis || 0) +
            parseFloat(this.state.retencaoCofins || 0) +
            parseFloat(this.state.retencaoCsll || 0)
        );
        console.log('Retenções > Valor?', this.testaValores());


        return (
            <div className='allContent'>
                {this.state.loading &&
                    <Skeleton />
                }

                {this.state.redirect &&
                    <Redirect to={'/'} />
                }

                {!this.state.loading &&
                    <>
                        <section>
                            {this.props.location.state.os &&
                                <Header voltarAddEvento evento={this.state.evento} os={this.props.location.state.os} titulo="Eventos" />
                            }
                            {!this.props.location.state.os &&
                                <Header voltarAddEvento evento={this.state.evento} titulo="Eventos" />
                            }
                            <div className="col-2"></div>
                            <br />
                            <br />
                        </section>

                        <ModalListas alteraModal={this.alteraModal} alteraSubgrupo={this.alteraSubgrupo} alteraPlanoConta={this.alteraPlanoConta} acessosPermissoes={this.state.acessosPermissoes} modalAberto={this.state.modalAberto} modal={this.state.modal} modalLista={this.state.modalLista} closeModal={() => { this.setState({ modalAberto: false }) }} pesquisa={this.state.modalPesquisa} />

                        <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            style={{ display: 'flex', justifyContent: 'center', paddingTop: '5%', paddingBottom: '5%', overflow: 'scroll' }}
                            open={this.state.contabiliza}
                            onClose={async () => await this.setState({ contabiliza: false, bloqueado: false, bloqueadoContabiliza: false })}
                        >
                            <div style={{
                                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                                padding: '30px',
                                borderRadius: '12px',
                                minWidth: 350,
                                maxWidth: 900,
                                width: '90%',
                                boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
                                border: '1px solid rgba(0,0,0,0.08)'
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                                    <h5 style={{ margin: 0, color: '#333', fontWeight: 600 }}>Informações para contabilização</h5>
                                    <div onClick={async () => await this.setState({ contabiliza: false, bloqueado: false, bloqueadoContabiliza: false })} style={{ cursor: 'pointer', fontSize: '1.5rem', color: '#888', fontWeight: 'bold' }}>
                                        <span>&times;</span>
                                    </div>
                                </div>


                                        <div>
                                            <Formik
                                                initialValues={{
                                                    name: '',
                                                }}
                                                onSubmit={async values => {
                                                    await new Promise(r => setTimeout(r, 1000))
                                                    this.salvarConta(validFormContabiliza)
                                                }}
                                            >
                                                <Form>

                                                    <div className="row">

                                                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ">

                                                            <div className="row" style={{ rowGap: '15px', alignItems: 'center' }}>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                    <label>Histórico Padrão</label>
                                                                </div>
                                                                <div className='col-1'></div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                    <Select className='SearchSelect' options={this.state.historicosOptions.filter(e => this.filterSearch(e, this.state.historicosOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ historicosOptionsTexto: e }) }} value={this.state.historicosOptions.filter(option => option.chave == this.state.historicoPadrao)[0]} search={true} onChange={(e) => { this.setState({ historico: e.label, historicoPadrao: e.chave }) }} />
                                                                </div>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                    <label>Histórico</label>
                                                                </div>
                                                                <div className='col-1 errorMessage'>
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                    <Field className="form-control" type="text" value={this.state.historico} onChange={async e => { this.setState({ historico: e.currentTarget.value }) }} />
                                                                </div>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                    <label>Cód. Barras</label>
                                                                </div>
                                                                <div className='col-1 errorMessage'>
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                    <Field className="form-control" type="text" value={this.state.codBarras} onChange={async e => { this.setState({ codBarras: e.currentTarget.value }) }} />
                                                                </div>
                                                                {(this.state.evento.tipo_sub != 2 && !this.state.repasse && this.state.tipo == 1) &&
                                                                    <>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Conta Débito</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.contaDebito &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-10 col-10">
                                                                            <Select className='SearchSelect'
                                                                                options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)}
                                                                                onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }}
                                                                                value={this.state.planosContasOptions.filter(option => option.value == this.state.contaDebito)[0]}
                                                                                search={true}
                                                                                onChange={(e) => { if (this.state.tipo != 0 || !this.state.repasse) { this.setState({ contaDebito: e.value, }) } }}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                }
                                                                {(this.state.evento.tipo_sub != 2 && !this.state.repasse && this.state.tipo === "0") &&
                                                                    <>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Conta Crédito</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.contaCredito &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-10 col-10">
                                                                            <Select className='SearchSelect'
                                                                                options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)}
                                                                                value={this.state.planosContasOptions.filter(option => option.value == this.state.contaCredito)[0]}
                                                                                onChange={(e) => { if (this.state.tipo != 1 || !this.state.repasse) { this.setState({ contaCredito: e.value, }) } }}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                }


                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                    <label>Meio de Pagamento</label>
                                                                </div>
                                                                <div className='col-1 errorMessage'>
                                                                    {!this.state.meioPagamento &&
                                                                        <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                    }
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                    <Select className='SearchSelect' options={this.state.meiosPagamentosOptions.filter(e => this.filterSearch(e, this.state.meiosPagamentosOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ meiosPagamentosOptionsTexto: e }) }} value={this.state.meiosPagamentosOptions.filter(option => option.value == this.state.meioPagamento)[0]} search={true} onChange={(e) => { this.setState({ meioPagamento: e.value, meioPagamentoNome: e.label }) }} />
                                                                </div>

                                                                {(this.state.meioPagamentoNome == 'DARF' || this.state.meioPagamentoNome == "GPS") &&
                                                                    <>
                                                                        <div>
                                                                            <hr />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Código da receita</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.codigoReceita &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control" type="text" value={this.state.codigoReceita} onChange={async e => { this.setState({ codigoReceita: e.currentTarget.value }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Contribuinte</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.contribuinte &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control" type="text" value={this.state.contribuinte} onChange={async e => { this.setState({ contribuinte: e.currentTarget.value }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Código identicador do tributo</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.codigoIdentificadorTributo &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control" type="text" value={this.state.codigoIdentificadorTributo} onChange={async e => { this.setState({ codigoIdentificadorTributo: e.currentTarget.value }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Número de referência</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.mesCompetNumRef &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control" type="text" value={this.state.mesCompetNumRef} onChange={async e => { this.setState({ mesCompetNumRef: e.currentTarget.value }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Data de Apuração</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.dataApuracao &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control" type="date" value={this.state.dataApuracao} onChange={async e => { this.setState({ dataApuracao: e.currentTarget.value }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Valor</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.darfValor &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control text-right" type="text" value={this.state.darfValor} onChange={async e => { this.setState({ darfValor: e.currentTarget.value }) }} onBlur={async e => { this.setState({ darfValor: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Multa</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.darfMulta &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control text-right" type="text" value={this.state.darfMulta} onChange={async e => { this.setState({ darfMulta: e.currentTarget.value }) }} onBlur={async e => { this.setState({ darfMulta: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Juros</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.darfJuros &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control text-right" type="text" value={this.state.darfJuros} onChange={async e => { this.setState({ darfJuros: e.currentTarget.value }) }} onBlur={async e => { this.setState({ darfJuros: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Valor de Pagamento</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.darfPagamento &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control text-right" type="text" value={this.state.darfPagamento} onChange={async e => { this.setState({ darfPagamento: e.currentTarget.value }) }} onBlur={async e => { this.setState({ darfPagamento: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                        </div>
                                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                            <label>Outros Valores</label>
                                                                        </div>
                                                                        <div className='col-1 errorMessage'>
                                                                            {!this.state.darfOutros &&
                                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                                            }
                                                                        </div>
                                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                                            <Field className="form-control text-right" type="text" value={this.state.darfOutros} onChange={async e => { this.setState({ darfOutros: e.currentTarget.value }) }} onBlur={async e => { this.setState({ darfOutros: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                        </div>
                                                                    </>
                                                                }

                                                            </div>
                                                        </div>
                                                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1"></div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-12" style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '20px' }}>
                                                            <button
                                                                disabled={!validFormContabiliza}
                                                                type="submit"
                                                                className='btn btn-success'
                                                                style={validFormContabiliza ? { width: 150 } : { width: 150, opacity: 0.5, cursor: 'not-allowed' }}
                                                            >
                                                                Enviar
                                                            </button>
                                                            <button
                                                                type="button"
                                                                onClick={async () => await this.setState({ contabiliza: false, bloqueado: false, bloqueadoContabiliza: false })}
                                                                style={{
                                                                    width: 150,
                                                                    padding: '10px 20px',
                                                                    background: '#6c757d',
                                                                    color: '#fff',
                                                                    border: 'none',
                                                                    borderRadius: '6px',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                    cursor: 'pointer',
                                                                    transition: 'all 0.3s',
                                                                    boxShadow: '0 4px 12px rgba(108, 117, 125, 0.2)'
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.target.style.background = '#5a6268';
                                                                    e.target.style.boxShadow = '0 6px 16px rgba(108, 117, 125, 0.3)';
                                                                    e.target.style.transform = 'translateY(-2px)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.target.style.background = '#6c757d';
                                                                    e.target.style.boxShadow = '0 4px 12px rgba(108, 117, 125, 0.2)';
                                                                    e.target.style.transform = 'translateY(0)';
                                                                }}
                                                            >
                                                                Cancelar
                                                            </button>
                                                        </div>
                                                    </div>

                                                </Form>
                                            </Formik>

                                        </div>
                                    </div>
                        </Modal >

                        <div className="page-breadcrumb2">
                            <h2>{parseInt(this.state.chave) === 0 ? 'Adicionar nova Solicitação' : 'Editar Solicitação'}</h2>
                        </div>


                        <div className="contact-section">

                            <div className="row">
                                <div className="col-lg-12">
                                    <Formik
                                        initialValues={{
                                            name: '',
                                        }}
                                        onSubmit={async values => {
                                            await new Promise(r => setTimeout(r, 1000))
                                            this.salvarServicoItem(validForm)
                                        }}
                                    >
                                        <Form className="contact-form" >

                                            <div className="row">
                                                <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"></div>

                                                <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 ">

                                                    <div className="row addservicos">
                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm firstLabel">
                                                            <label>Chave</label>
                                                        </div>
                                                        <div className='col-1'></div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Field className="form-control" style={{ backgroundColor: '#dddddd' }} type="text" disabled value={this.state.chave} />
                                                        </div>
                                                        <div className="col-1"></div>


                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                            <label>Emissão</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                        </div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Field className="form-control" type="date" value={this.state.emissao} onChange={async e => { this.setState({ emissao: e.currentTarget.value }) }} />
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                        </div>
                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                            <label>Documento</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                        </div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Field className="form-control" type="text" value={this.state.documento} onChange={async e => { this.setState({ documento: e.currentTarget.value }); this.alteraComplementoRetencoes(); }} />
                                                        </div>
                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                            <label>Tipo de Documento</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                        </div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Select className='SearchSelect' options={this.state.tiposDocumentosOptions.filter(e => this.filterSearch(e, this.state.tiposDocumentosOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ tiposDocumentosOptionsTexto: e }) }} value={this.state.tiposDocumentosOptions.filter(option => option.label == this.state.tipoDocumento)[0]} search={true} onChange={(e) => { this.setState({ tipoDocumento: e.value }) }} />
                                                        </div>
                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                            <label>Vencimento</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                        </div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Field className="form-control" type="date" value={this.state.vencimento} onChange={async e => { this.setState({ vencimento: e.currentTarget.value }) }} />
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                        </div>


                                                        {/* BLOCO DE VALORES */}
                                                        <div className="col-12 labelForm text-center mb-2 mt-4">
                                                            <label>Valores e ROE</label>
                                                        </div>

                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm mt-2">
                                                            <label>Valor total em dólar</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'></div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Field className="form-control text-right" type="text" disabled value={this.state.valor} style={{ backgroundColor: '#dddddd' }} />
                                                        </div>
                                                        <div className="col-1"></div>
                                                        
                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm mt-2">
                                                            <label style={{ fontSize: '0.85rem' }}>Valor total original (R$) (ROE original a R${this.state.roeOriginal ? this.state.roeOriginal.toString().replace('.', ',') : '1,000'})</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'></div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Field className="form-control text-right" type="text" disabled value={this.state.valorOriginalReais} style={{ backgroundColor: '#dddddd' }} />
                                                        </div>
                                                        <div className="col-1"></div>

                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm mt-2">
                                                            <label>ROE</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'></div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Field className="form-control text-right" type="number" step="0.0001" value={this.state.roe} onChange={this.handleChangeROE} />
                                                        </div>
                                                        <div className="col-1"></div>
                                                        
                                                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm mt-2">
                                                            <label>Valor total final em reais</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                            {(!this.state.vlrc || parseFloat(this.state.vlrc.replaceAll('.', '').replaceAll(',', '.')) <= 0) &&
                                                                <FontAwesomeIcon title='Preencha o campo' icon={faExclamationTriangle} />
                                                            }
                                                        </div>
                                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                                                            <Field
                                                                disabled={true}
                                                                style={{ backgroundColor: '#dddddd' }}
                                                                className="form-control text-right"
                                                                type="text"
                                                                onClick={(e) => e.target.select()}
                                                                value={this.state.vlrc}
                                                                onChange={async e => {
                                                                    this.setState({ vlrc: e.currentTarget.value });
                                                                    if (this.state.repasse) {
                                                                        this.setState({ valor: e.currentTarget.value });
                                                                    }
                                                                }}
                                                                onBlur={async e => {
                                                                    const formatted = Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.'))
                                                                        ? new Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.'))
                                                                        : util.formatVcpDefault(this.state.valor, 0);
                                                                    this.setState({ vlrc: formatted });
                                                                    if (this.state.repasse) {
                                                                        this.setState({ valor: formatted });
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-1 errorMessage"></div>

                                                        {/* BLOCO DE CONTAS CONTÁBEIS (DINÂMICO) */}
                                                        <div className="col-12 labelForm text-center mb-2 mt-4">
                                                            <label>Contas Contábeis (Classificação)</label>
                                                        </div>

                                                        {/* CONTA CLIENTE */}
                                                        {(this.state.tipo == 0 || this.state.tipo == 2 || this.state.tipo == 3 || (this.state.tipo == 1 && this.state.repasse)) && (
                                                            <>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                    <label>Conta Cliente</label>
                                                                </div>
                                                                <div className='col-1 errorMessage'>
                                                                    {!this.state.contaCliente &&
                                                                        <FontAwesomeIcon title='A Conta do Cliente é obrigatória para este tipo de evento' icon={faExclamationTriangle} style={{ color: 'red' }} />
                                                                    }
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 mb-2">
                                                                    <Select
                                                                        className='SearchSelect'
                                                                        options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)}
                                                                        onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }}
                                                                        value={this.state.planosContasOptions.filter(option => option.value == this.state.contaCliente)[0] || null}
                                                                        search={true}
                                                                        placeholder="Selecione a Conta do Cliente..."
                                                                        onChange={(e) => { this.setState({ contaCliente: e.value }) }}
                                                                    />
                                                                </div>
                                                            </>
                                                        )}

                                                        {/* CONTA FORNECEDOR */}
                                                        {this.state.tipo == 1 && (
                                                            <>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                    <label>Conta Fornecedor</label>
                                                                </div>
                                                                <div className='col-1 errorMessage'>
                                                                    {(!this.state.contaFornecedor && !this.state.contaFornecedorCusteio) &&
                                                                        <FontAwesomeIcon title='A Conta do Fornecedor é obrigatória para eventos a pagar' icon={faExclamationTriangle} style={{ color: 'red' }} />
                                                                    }
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 mb-2">
                                                                    <Select
                                                                        className='SearchSelect'
                                                                        options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)}
                                                                        onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }}
                                                                        value={this.state.planosContasOptions.filter(option => option.value == (this.state.contaFornecedor || this.state.contaFornecedorCusteio))[0] || null}
                                                                        search={true}
                                                                        placeholder="Selecione a Conta do Fornecedor..."
                                                                        onChange={(e) => { this.setState({ contaFornecedor: e.value, contaFornecedorCusteio: e.value }) }}
                                                                    />
                                                                </div>
                                                            </>
                                                        )}

                                                        {/* CONTA TAXA */}
                                                        {this.state.tipo == 0 && (
                                                            <>
                                                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                                                                    <label>Conta da Taxa</label>
                                                                </div>
                                                                <div className='col-1 errorMessage'>
                                                                    {!this.state.contaTaxa &&
                                                                        <FontAwesomeIcon title='A Conta da Taxa é obrigatória para eventos a receber' icon={faExclamationTriangle} style={{ color: 'red' }} />
                                                                    }
                                                                </div>
                                                                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10 mb-2">
                                                                    <Select
                                                                        className='SearchSelect'
                                                                        options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)}
                                                                        onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }}
                                                                        value={this.state.planosContasOptions.filter(option => option.value == this.state.contaTaxa)[0] || null}
                                                                        search={true}
                                                                        placeholder="Selecione a Conta da Taxa..."
                                                                        onChange={(e) => { this.setState({ contaTaxa: e.value }) }}
                                                                    />
                                                                </div>
                                                            </>
                                                        )}
                                                        <div><hr /></div>

                                                        <div className="col-12 labelForm text-center">
                                                            <label>Retenções</label>
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                        </div>
                                                        <div className="col-12 checkboxesDiv">
                                                            <div>
                                                                <label className='smallCheckbox'>INSS</label>
                                                                <input className='smallCheckbox' type='checkbox' checked={this.state.retencaoInssCheck} onChange={async (e) => { await this.mudaRetencao("INSS") }} />
                                                            </div>
                                                            <div>
                                                                <label className='smallCheckbox'>IR</label>
                                                                <input className='smallCheckbox' type='checkbox' checked={this.state.retencaoIrCheck} onChange={async (e) => { await this.mudaRetencao("IR") }} />
                                                            </div>
                                                            <div>
                                                                <label className='smallCheckbox'>ISS</label>
                                                                <input className='smallCheckbox' type='checkbox' checked={this.state.retencaoIssCheck} onChange={async (e) => { await this.mudaRetencao("ISS") }} />
                                                            </div>
                                                            <div>
                                                                <label className='smallCheckbox'>CRF</label>
                                                                <input className='smallCheckbox' type='checkbox' checked={this.state.retencaoCsllCheck} onChange={async (e) => { await this.mudaRetencao("CSLL") }} />
                                                            </div>
                                                        </div>
                                                        <div className='col-1 errorMessage'>
                                                        </div>
                                                        <div><hr /></div>
                                                        <div className='col-12 text-center' style={{ height: '25px' }}>
                                                            <label>Desconto</label>
                                                        </div>
                                                        <div className='col-4 text-center' style={{ height: '25px' }}>
                                                            <label>Conta</label>
                                                        </div>
                                                        <div className='col-4 text-center' style={{ height: '25px' }}>
                                                            <label>Valor</label>
                                                        </div>
                                                        <div className='col-4 text-center' style={{ height: '25px' }}>
                                                            <label>Complem.</label>
                                                        </div>
                                                        <div className="col-4">
                                                            <Select isDisabled={!this.state.descontoConta} className='SearchSelect' options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }} value={this.state.planosContasOptions.filter(option => option.value == this.state.descontoConta)[0]} />
                                                        </div>
                                                        <div className='col-4'>
                                                            <Field className="form-control nextToSelect text-right" type="text" onClick={(e) => e.target.select()} value={this.state.desconto} onChange={async e => { this.setState({ desconto: e.currentTarget.value }) }} onBlur={async e => { this.setState({ desconto: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                        </div>
                                                        <div className='col-4'>
                                                            <Field className="form-control nextToSelect" type="text" value={this.state.descontoComplemento} onChange={async e => { this.setState({ descontoComplemento: e.currentTarget.value }) }} />
                                                        </div>
                                                        {this.state.retencaoInssCheck &&
                                                            <>
                                                                <div><hr /></div>
                                                                <div className='col-12 text-center' style={{ height: '25px' }}>
                                                                    <label>Retenção INSS</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Conta</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Valor</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Complem.</label>
                                                                </div>
                                                                <div className="col-4">
                                                                    <Select className='SearchSelect' options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }} value={this.state.planosContasOptions.filter(option => option.value == this.state.retencaoInssConta)[0]} search={true} isDisabled={!this.state.retencaoInssConta} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect text-right" type="text" onClick={(e) => e.target.select()} value={this.state.retencaoInss} onChange={async e => { this.setState({ retencaoInss: e.currentTarget.value }) }} onBlur={async e => { this.setState({ retencaoInss: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect" type="text" value={this.state.retencaoInssComplemento} onChange={async e => { this.setState({ retencaoInssComplemento: e.currentTarget.value }) }} />

                                                                </div>
                                                            </>
                                                        }
                                                        {this.state.retencaoIrCheck &&
                                                            <>
                                                                <div><hr /></div>
                                                                <div className='col-12 text-center' style={{ height: '25px' }}>
                                                                    <label>Retenção IR</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Conta</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Valor</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Complem.</label>
                                                                </div>
                                                                <div className="col-4">
                                                                    <Select className='SearchSelect' options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }} value={this.state.planosContasOptions.filter(option => option.value == this.state.retencaoIrConta)[0]} search={true} onChange={(e) => this.setState({ retencaoIrConta: e.value })} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect text-right" type="text" onClick={(e) => e.target.select()} value={this.state.retencaoIr} onChange={async e => { this.setState({ retencaoIr: e.currentTarget.value }) }} onBlur={async e => { this.setState({ retencaoIr: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect" type="text" value={this.state.retencaoIrComplemento} onChange={async e => { this.setState({ retencaoIrComplemento: e.currentTarget.value }) }} />

                                                                </div>
                                                            </>
                                                        }
                                                        {this.state.retencaoIssCheck &&
                                                            <>
                                                                <div><hr /></div>
                                                                <div className='col-12 text-center' style={{ height: '25px' }}>
                                                                    <label>Retenção ISS</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Conta</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Valor</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Complem.</label>
                                                                </div>
                                                                <div className="col-4">
                                                                    <Select className='SearchSelect' options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }} value={this.state.planosContasOptions.filter(option => option.value == this.state.retencaoIssConta)[0]} search={true} isDisabled={!this.state.retencaoIssConta} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect text-right" type="text" onClick={(e) => e.target.select()} value={this.state.retencaoIss} onChange={async e => { this.setState({ retencaoIss: e.currentTarget.value }) }} onBlur={async e => { this.setState({ retencaoIss: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect" type="text" value={this.state.retencaoIssComplemento} onChange={async e => { this.setState({ retencaoIssComplemento: e.currentTarget.value }) }} />

                                                                </div>
                                                            </>
                                                        }
                                                        {this.state.retencaoPisCheck &&
                                                            <>
                                                                <div><hr /></div>
                                                                <div className='col-12 text-center' style={{ height: '25px' }}>
                                                                    <label>Retenção PIS</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Conta</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Valor</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Complem.</label>
                                                                </div>
                                                                <div className="col-4">
                                                                    <Select className='SearchSelect' options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }} value={this.state.planosContasOptions.filter(option => option.value == this.state.retencaoPisConta)[0]} search={true} isDisabled={this.state.retencaoPisConta} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect text-right" type="text" onClick={(e) => e.target.select()} value={this.state.retencaoPis} onChange={async e => { this.setState({ retencaoPis: e.currentTarget.value }) }} onBlur={async e => { this.setState({ retencaoPis: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect" type="text" value={this.state.retencaoPisComplemento} onChange={async e => { this.setState({ retencaoPisComplemento: e.currentTarget.value }) }} />

                                                                </div>
                                                            </>
                                                        }
                                                        {this.state.retencaoCofinsCheck &&
                                                            <>
                                                                <div><hr /></div>
                                                                <div className='col-12 text-center' style={{ height: '25px' }}>
                                                                    <label>Retenção COFINS</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Conta</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Valor</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Complem.</label>
                                                                </div>
                                                                <div className="col-4">
                                                                    <Select className='SearchSelect' options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }} value={this.state.planosContasOptions.filter(option => option.value == this.state.retencaoCofinsConta)[0]} search={true} isDisabled={!this.state.retencaoCofinsConta} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect text-right" type="text" onClick={(e) => e.target.select()} value={this.state.retencaoCofins} onChange={async e => { this.setState({ retencaoCofins: e.currentTarget.value }) }} onBlur={async e => { this.setState({ retencaoCofins: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect" type="text" value={this.state.retencaoCofinsComplemento} onChange={async e => { this.setState({ retencaoCofinsComplemento: e.currentTarget.value }) }} />

                                                                </div>
                                                            </>
                                                        }
                                                        {this.state.retencaoCsllCheck &&
                                                            <>
                                                                <div><hr /></div>
                                                                <div className='col-12 text-center' style={{ height: '25px' }}>
                                                                    <label>Retenções CRF</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Conta</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Valor</label>
                                                                </div>
                                                                <div className='col-4 text-center' style={{ height: '25px' }}>
                                                                    <label>Complem.</label>
                                                                </div>
                                                                <div className="col-4">
                                                                    <Select className='SearchSelect' options={this.state.planosContasOptions.filter(e => this.filterSearch(e, this.state.planosContasOptionsTexto)).slice(0, 20)} onInputChange={e => { this.setState({ planosContasOptionsTexto: e }) }} value={this.state.planosContasOptions.filter(option => option.value == this.state.retencaoCsllConta)[0]} search={true} isDisabled={!this.state.retencaoCsllConta} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect text-right" type="text" onClick={(e) => e.target.select()} value={this.state.retencaoCsll} onChange={async e => { this.setState({ retencaoCsll: e.currentTarget.value }) }} onBlur={async e => { this.setState({ retencaoCsll: Number(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) ? new Intl.NumberFormat('pt-BR').format(e.currentTarget.value.replaceAll('.', '').replaceAll(',', '.')) : '' }) }} />
                                                                </div>
                                                                <div className='col-4'>
                                                                    <Field className="form-control nextToSelect" type="text" value={this.state.retencaoCsllComplemento} onChange={async e => { this.setState({ retencaoCsllComplemento: e.currentTarget.value }) }} />

                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                    <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1"></div>
                                                </div>

                                                <div className="row">
                                                    {!this.state.conta && this.state.evento.centroCusto != '0' && (this.state.tipo == 1 && (this.state.repasse && this.state.contaCliente && (this.state.contaFornecedor || this.state.contaFornecedorCusteio)) || (!this.state.repasse && (this.state.contaFornecedor || this.state.contaFornecedorCusteio)) || this.state.tipo == 0 && (this.state.contaCliente && this.state.contaTaxa) || this.state.tipo == 2 && (this.state.contaCliente) || this.state.tipo == 3 && (this.state.contaCliente)) && !this.testaValores() &&
                                                        <>
                                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <button disabled={!validForm} type="submit" style={validForm ? { width: 300 } : { backgroundColor: '#eee', opacity: 0.3, width: 300 }} >Salvar</button>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <button disabled={!validForm} onClick={() => { this.contabilizar(validForm) }} style={validForm ? { width: 300 } : { backgroundColor: '#eee', opacity: 0.3, width: 300 }} >Contabilizar</button>
                                                            </div>
                                                        </>
                                                    }
                                                    {!(!this.state.conta && this.state.evento.centroCusto != '0' && (this.state.tipo == 1 && (this.state.repasse && this.state.contaCliente && (this.state.contaFornecedor || this.state.contaFornecedorCusteio)) || (!this.state.repasse && (this.state.contaFornecedor || this.state.contaFornecedorCusteio)) || this.state.tipo == 0 && (this.state.contaCliente && this.state.contaTaxa) || this.state.tipo == 2 && (this.state.contaCliente) || this.state.tipo == 3 && (this.state.contaCliente)) && !this.testaValores()) &&
                                                        <>
                                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <button disabled={!validForm} type="submit" style={validForm ? { width: 300 } : { backgroundColor: '#eee', opacity: 0.3, width: 300 }} >Salvar</button>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                                <button
                                                                    title={this.state.conta ? "Esta solicitação já foi contabilizada" : this.state.evento.centroCusto == '0' ? "Nenhum centro de custo vinculado" : this.testaValores() ? "Valores de retenções ultrapassam o valor do evento" : "Faltam contas (débito e/ou crédito)"}
                                                                    disabled
                                                                    style={{ backgroundColor: '#eee', opacity: 0.3, width: 300 }}
                                                                >Contabilizar</button>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </div>

                                        </Form>
                                    </Formik>
                                </div>
                            </div>

                        </div>
                        <Rodape />
                    </>
                }
            </div>
        )

    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        user: user,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddEventoFinanceiro)

